export default "__VITE_ASSET__7953d9fe__"